import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const stepTitleSx: SxProps<Theme> = {
	width: 'fit-content',
	fontWeight: OpenSansFontWeights.light,
	color: 'grey.500',
	borderBottom: '2px solid',
	borderBottomColor: 'primary.main',
	marginBottom: '5px',
	fontSize: '27px',
};

export const stepTitleDividerSx: SxProps<Theme> = {
	marginBottom: '5px',
	borderColor: 'grey.50',
};

export const stepContainerSx: SxProps<Theme> = {
	width: '100%',
	marginBottom: '10px',
};
